export const getCurrentCanvas = (cardFace) => {
  const currentCanvasRef = cardFace?.canvas?.current;
  if (!currentCanvasRef) {
    // eslint-disable-next-line no-console
    console.debug('Unable to located current canvas');
  }

  return currentCanvasRef;
};
